import React from 'react';

// Base
import Col from '../../../../base/col';
import Row from '../../../../base/row';

// Related Components
import LoadingListing from './listing/loading';

export default class Loading extends React.PureComponent {
  render() {
    return (
      <div className='fixed-width-layout margin-top-20'>
        <div className='full-width-content'>
          <Row nested>
            <Col s={12} className='secondary-color med-font margin-bottom-10'>
              Jobs
            </Col>
            {
              [...Array(10)].map((_, i) => (
                <Col s={12} key={i}>
                  <LoadingListing />
                </Col>
              ))
            }
          </Row>
        </div>
      </div>
    )
  }
}